module.exports = __webpack_public_path__ + "img/what_about_here.75634f59.png";